
import toastr from 'toastr';

angular.module("contact_types")

    .controller("ContactTypesEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$uibModal', 'logService',
        function (LoginService, $scope, $rootScope, $state, $stateParams, Restangular, gridService, $filter, $translate, modalService, $uibModal, logService) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("CONTACT_TYPES_WRITE");

            $scope.id = $stateParams.id;
            $rootScope.title = $filter('translate')('contact_types.title');
            $scope.contact_type = {};

            if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

                $rootScope.breadcrumb = [
                    { title: $filter('translate')('contact_types.title'), url: "contact_types.list" },
                    { title: $filter('translate')('contact_types.title_add') },
                ];

            } else {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('contact_types.title'), url: "contact_types.list" },
                    { title: $filter('translate')('contact_types.title_edit') },
                ];

                Restangular.one('ContactsTypes', $scope.id).get().then(function (result) {
                    $scope.contact_type = result;
                    logService.debug($scope.contact_type)
                });
            }

            $scope.saveContactType = function () {
                logService.debug("Este es el tipo de contacto")
                logService.debug($scope.contact_type);
                if (angular.isDefined($scope.id) && $scope.id != "") {
                    $scope.contact_type.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('contact_types.save_success'));
                             $state.go("contact_types.list");
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                } else {
                    Restangular.all('ContactsTypes').post($scope.contact_type).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('contact_types.edit_success'));
                             $state.go("contact_types.list");
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                }
            }

            $scope.checkDelete = function () {
                modalService.confirm({
                    title: $filter('translate')('contact_types.button_delete'),
                    message: $filter('translate')('contact_types.delete_message') + " " + $scope.contact_type.name + "?",
                    onAccept: function () {
                        $scope.contact_type.remove().then(function () {
                            toastr.success($filter('translate')('contact_types.deleted_success'));
                            $state.go("contact_types.list");
                        });
                    }
                });
            };

        }])

;

